import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  // TODO: TEMPORAL - auto-login como Directivo, quitar antes de producción
  if (!auth.isLoggedIn()) {
    sessionStorage.setItem('vs_session', JSON.stringify({ email: 'admin@dev.local', name: 'Admin Dev', role: 'Directivo' }));
  }
  return true;
};
